import { render, staticRenderFns } from "./TagOutline.vue?vue&type=template&id=24a99540"
import script from "./TagOutline.vue?vue&type=script&lang=js"
export * from "./TagOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports